import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

type PairingQrProps = {
  value: string;
  size?: number;
};

export function PairingQr({ value, size = 220 }: PairingQrProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void QRCode.toDataURL(value, {
      width: size,
      margin: 2,
      color: { dark: '#050505', light: '#ffffff' },
    }).then((url) => {
      if (!cancelled) setDataUrl(url);
    });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (!dataUrl) {
    return <div className="pairing-screen__qr-skeleton" aria-hidden />;
  }

  return (
    <img
      className="pairing-screen__qr"
      src={dataUrl}
      alt="QR code to connect this display"
    />
  );
}
